import { mutate } from 'swr';
// logic
import quoteService from '../../quoteService';
// components
import '../../ui/emergencyPopup.css';
import { Modal } from 'react-async-popup';
import AcceptQuoteModal from './acceptQuoteModal';

const useAcceptQuoteModal = (ticket, quote) => {
  const acceptQuoteModalProps = { ticket, quote };
  const acceptQuoteModal = async () => {
    const { show } = await Modal.new({
      content: (
        <AcceptQuoteModal acceptQuoteModalProps={acceptQuoteModalProps} />
      ),
      footer: null,
    });
    const result = await show();
    return result;
  };

  const quoteId = quote?.id;
  const ticketId = ticket?.id;

  const openAcceptQuoteModal = async () => {
    const result = await acceptQuoteModal();
    if (result) {
      await quoteService.callBackend.acceptQuote({ quoteId, ticketId });
      // we are mutating the tickets cache so it will reload automatically
      mutate((key) => {
        return typeof key === 'string' && key.startsWith('tickets');
      });
    }
  };

  return {
    openAcceptQuoteModal,
  };
};

export default useAcceptQuoteModal;
